import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Flyer } from "./components/Flyer";
import { Experience } from "./components/Experience";
import { Bottomless } from "./components/Bottomless";
import { GuestList } from "./components/GuestList";
import { JoinTeam } from "./components/JoinTeam";
import { InstaGrid } from "./components/InstaGrid";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="grain relative min-h-screen bg-[#09080B]">
      <Nav />
      <main>
        <Hero />
        <Flyer />
        <Marquee />
        <Experience />
        <Bottomless />
        <GuestList />
        <JoinTeam />
        <InstaGrid />
        <Contact />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
